import { render } from "./Identity_check.vue?vue&type=template&id=34a7c895"
import script from "./Identity_check.vue?vue&type=script&lang=js"
export * from "./Identity_check.vue?vue&type=script&lang=js"

import exportComponent from "/Users/jean/Desktop/Git-project/distell_invoice_backend_dist/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__